import { render, staticRenderFns } from "./MpCard.vue?vue&type=template&id=67a28f66&scoped=true&"
import script from "./MpCard.vue?vue&type=script&lang=js&"
export * from "./MpCard.vue?vue&type=script&lang=js&"
import style0 from "./MpCard.vue?vue&type=style&index=0&id=67a28f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a28f66",
  null
  
)

export default component.exports